import React from 'react';
import { Container } from '@michelin/acid-components';
import GLOBAL_CONFIG from 'global-variables';

export function RequestServiceModule() {
  return (
    <>
      <Container height="100%" spacing={0}>
        <iframe title="Request Service" src={GLOBAL_CONFIG.esdUrl} style={{ border: 'none', flex: 1 }} />
      </Container>
    </>
  );
}
